/**
 * @author    Nikko Renolds
 * @package		Trap Tycoon
 * @link		  https://github.com/Ni1kko/Trap-Tycoon
 * @copyright (c) Fallox Developments2026.
 * @license		MIT
 * @description Frontend component displaying fight logs from previous combats.
 */

import React, { useEffect, useState } from "react";
import { callBackend } from "../utils/api";

export default function FightLogs() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    callBackend("/fight-logs/fetch").then(setLogs);
  }, []);

  return (
    <div className="bg-zinc-900 border-2 border-red-900/40 p-6 shadow-2xl font-mono">
      <h3 className="text-red-600 font-black italic mb-4 uppercase">
        Combat History
      </h3>
      <div className="space-y-2 max-h-60 overflow-y-auto">
        {logs.map((log) => (
          <div
            key={log.id}
            className="text-[10px] border-l-2 border-zinc-700 pl-2 py-1"
          >
            <span className="text-zinc-500">
              [{new Date(log.created_at).toLocaleTimeString()}]
            </span>{" "}
            <span
              className={
                log.winner_id === log.attacker_id
                  ? "text-green-500"
                  : "text-red-500"
              }
            >
              {log.result_text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
